import Axios from "../baseApi";
export default {
  async fetch() {
    return Axios.get('/api-master-data/v1/bank');
  },
  async create(data) {
    try{
      const response = await Axios.put('/api-master-data/v1/bank', data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async update(id, data) {
    try{
      const response = await Axios.post('/api-master-data/v1/bank/' + id, data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async delete(id) {
    try{
      const response = await Axios.delete('/api-master-data/v1/bank/' + id);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
